import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosViagensNacionais = {
    ...dadosAgenciaComum,
    id: 'viagensnacionais',
    nome: 'Viagens Nacionais',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-MDG2HLZ']
};
